import { getDefaultGlobalStore, getDistributorStores, getSupplierStores, updateStore, getApparelSizes } from '../../../api/stores';
import { EDIT_STORE, GET_ALL_STORES, GET_TEMPLATE_STORES, SET_CURRENT_STORE, SET_STORE_URL, SET_APPAREL_SIZES } from './constants';
import router from '@/router';
import { BAD_UPDATE, SUCCESS_UPDATED } from '../constants';
import { PLAN_TOOLS } from '../../../portals/utils';
export default {
  async getAll({ commit }) {
    try {
      const { name = '' } = router.currentRoute;
      const isAdminPortal = name.includes('admin');
      const isSupplierPortal = name.includes('supplier');
      let data = [];
      let templateStores = data.filter((i) => i.isTemplate);
      const { loggedInUser } = this.getters;
      if (
        !isAdminPortal &&
        (loggedInUser.distributorId.plans.find((plan) => plan.tools.product.includes(PLAN_TOOLS.PRODUCT[0].value)) ||
          !loggedInUser.distributorId.defaultStoreId)
      ) {
        data = await getDefaultGlobalStore();
      } else if (isSupplierPortal) {
        const { supplierId } = loggedInUser;
        data = supplierId ? await getSupplierStores(typeof supplierId === 'string' ? supplierId : supplierId._id) : [];
      } else if (!isAdminPortal && loggedInUser.distributorId) {
        data = await getDistributorStores(loggedInUser.distributorId._id);
      } else {
        await getDistributorStores('all');
      }
      commit(GET_ALL_STORES, data);
      commit(GET_TEMPLATE_STORES, templateStores);
      return data;
    } catch (e) {}
  },
  async editStore({ commit, state }, { payload, successMessage }) {
    try {
      await updateStore(payload);
      commit(EDIT_STORE, payload.data);
      commit(SUCCESS_UPDATED, successMessage || 'Store updated', { root: true });
    } catch (e) {
      commit(BAD_UPDATE, e.data ? e.data.message : e.message || e, { root: true });
    } finally {
    }
  },
  async editStoreV1({ commit, state }, payload) {
    commit(EDIT_STORE, payload.data);
  },
  async setStoreUrl({ commit }, data) {
    commit(SET_STORE_URL, data);
  },
  async setStore({ commit }, data) {
    commit(SET_CURRENT_STORE, data);
  }
};
